
import { Vue, Component, Prop } from 'vue-property-decorator'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import axios from 'axios'
import ButtonContained from '@/components/common/buttons/ButtonContained.vue'
import { AuthViewData } from '@/components/common/modals/ModalAuthentication.vue'

@Component({
  components: {
    ButtonContained,
    ValidationProvider,
    ValidationObserver
  }
})
export default class ResetPassword extends Vue {
  @Prop({ type: Object, required: true }) readonly view!: AuthViewData
  @Prop() currentView!: object

  isProcessing = false

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  }

  private data = {
    email: ''
  }

  private validateThenEmitFormData() {
    this.$refs.observer.validate().then((success) => {
      if (!success || this.isProcessing) { return }

      this.isProcessing = true

      const data = new FormData()
      data.append('email', this.data.email)

      axios
        .post('/post-forgot-password', data, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        })
        .catch((err) => {
          this.isProcessing = false
          this.$sentry.captureException(err)
        })
        .then(() => {
          this.isProcessing = false
          this.$emit('set-view', 'resetSuccess')
        })
    })
  }
}
